<div [class]="containerClass()">
  @for (totalKeyName of totalKeysName; track totalKeyName) {
    @let isAvailable = available()?.[totalKeyName] ?? false;
    @let totalValue = totals?.[totalKeyName] ?? 0;
    @let info = totalsInfo[totalKeyName];
    @let isRotate = rotate()?.[totalKeyName] ?? false;
    @let names = (totalKeyName === 'reactions' ? reactionsName() : null) ?? info.name;
    @let displayName = totalValue > 1 ? names.plural : names.single;
    @let translatedName = displayName | transloco;

    @if (isAvailable && (isLoading || !hideIfEmpty() || totalValue > 0)) {
      <div
        [class]="counterClass()"
        [class.opacity-0]="isLoading"
        [class.cursor-pointer]="info.clickEmitter?.observed"
        [zTooltip]="tooltipHasCount() ? totalValue + ' ' + translatedName : translatedName"
        (click)="!isLoading && info.clickEmitter?.emit()"
      >
        @if (type() === 'icon') {
          <ng-icon
            [name]="isDesignSystem() ? info.designSystemIcon : info.icon"
            [class]="iconClass()"
            [class.-scale-x-1]="isRotate"
          ></ng-icon>
        }
        <div
          [class.text-sm]="isDesignSystem() || type() === 'text'"
          [class.text-xs]="!isDesignSystem() && type() === 'icon'"
        >
          {{ totalValue | formatNumberDefault }}
        </div>
        @if (type() === 'text') {
          <div class="text-sm">{{ translatedName }}</div>
        }
      </div>
    }
  }
  @if (isLoading) {
    <ngx-skeleton-loader
      [class.on-primary]="onPrimary()"
      class="absolute inset-0"
      [theme]="{ width: '100%', height: '100%', marginBottom: 0 }"
    ></ngx-skeleton-loader>
  }
</div>
